import { render, staticRenderFns } from "./selectTemplateModal.vue.html?vue&type=template&id=06d1bc7a&scoped=true"
import script from "./selectTemplateModal.controller?vue&type=script&lang=js&external"
export * from "./selectTemplateModal.controller?vue&type=script&lang=js&external"
import style0 from "./selectTemplateModal.vue.html?vue&type=style&index=0&id=06d1bc7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d1bc7a",
  null
  
)

export default component.exports